import {
  TESTSESSIONQUESTION_LOAD,
} from '../constants';

const initialState = {
  nextTestSessionQuestion: {},
};

export default function update(state = initialState, action) {
  if (action.type === TESTSESSIONQUESTION_LOAD) {
    return { ...state, nextTestSessionQuestion: action.testSessionQuestion };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/testsession.js